<base-modal-component class="base-modal" [validation]="isValid()" (onConfirm)="save()">
    <fields-list-component [fields]="fields" name="companies_edit" [value]="company"></fields-list-component>
</base-modal-component>
